module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_tamil.415be017.mp3";